const Catalog = 'Catalog';

export const FETCH_CATALOG_FIELD_TYPES_REQUEST = `${Catalog}/FETCH_CATALOG_FIELD_TYPES_REQUEST`;
export const FETCH_CATALOG_FIELD_TYPES_RESPONSE = `${Catalog}/FETCH_CATALOG_FIELD_TYPES_RESPONSE`;
export const FETCH_CATALOG_FIELD_TYPES_ERROR = `${Catalog}/FETCH_CATALOG_FIELD_TYPES_ERROR`;

export const UPDATE_CATALOG_FIELD_TYPES_REQUEST = `${Catalog}/UPDATE_CATALOG_FIELD_TYPES_REQUEST`;
export const UPDATE_CATALOG_FIELD_TYPES_RESPONSE = `${Catalog}/UPDATE_CATALOG_FIELD_TYPES_RESPONSE`;
export const UPDATE_CATALOG_FIELD_TYPES_ERROR = `${Catalog}/UPDATE_CATALOG_FIELD_TYPES_ERROR`;

export const CHANGE_CATALOG_FIELD_TYPES_VIEW_MODE = `${Catalog}/CHANGE_CATALOG_FIELD_TYPES_VIEW_MODE`;

export const UPDATE_AND_FETCH_CATALOG_FIELD_TYPES = `${Catalog}/UPDATE_AND_FETCH_CATALOG_FIELD_TYPES`;
export const UPDATE_AND_FETCH_CATALOG_FIELD_TYPES_ERROR = `${Catalog}/UPDATE_AND_FETCH_CATALOG_FIELD_TYPES_ERROR`;
